import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Etiquetadora.types'
import { IEtiquetadora } from './Etiquetadora.lib';

export class Etiquetadora extends IEtiquetadora{

    public static async create( id: number ): Promise<Etiquetadora> {
        let o = new Etiquetadora();
        o.Id = id;
        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/etiquetadoras';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Etiquetadora>; Error?: boolean; }> {

        let a: Array<Etiquetadora> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/etiquetadoras` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Etiquetadora( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }
}